import { useEffect, useState } from 'react';

/**
 * THE right-panel breakpoint (agent_docs/right_panel_coherence_prd.md §1):
 *   >= 1024px — surfaces open in the 50/50 split slot (Expand to fullscreen optional);
 *   <  1024px — surfaces open as direct full-viewport takeovers (no split exists).
 * Every right-panel surface consumes THIS constant/hook — never re-declare the number.
 * (CSS media queries mirror it at 1023/1024px; useEmpPanelTier's 1280 'inline' boundary is
 * rail-specific legacy — its 1024 edge comes from here.)
 */
export const DESKTOP_MIN_PX = 1024;

export const isDesktopViewport = () =>
  typeof window !== 'undefined' ? window.innerWidth >= DESKTOP_MIN_PX : false;

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport);
  useEffect(() => {
    const onResize = () => setIsDesktop(isDesktopViewport());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isDesktop;
};

export default useIsDesktop;
